export default __webpack_public_path__ + "static/media/pk.acaf672a.svg";